// Example using react-i18next
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enJSON } from "./constants/translations/en";
import { deJSON } from "./constants/translations/de";
import { itJSON } from "./constants/translations/it";
import { frJSON } from "./constants/translations/fr";


i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enJSON,
    },
    de: {
      translation: deJSON,
    },
    it:{
      translation: itJSON,
    },
    fr:{
      translation: frJSON,
    }
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;